// components/GettingStarted/SidebarNav.js
import React from "react";

export default function SidebarNav({
  mainTabs,
  carTabs,
  carSubTabConfig,
  activeMainTab,
  activeCar,
  activeCarSubTab,
  handleMainTabClick,
  handleCarClick,
  handleCarSubTabClick,
  sidebarOpen,
  setSidebarOpen,
}) {
  const SidebarContent = () => (
    <nav className="bg-white rounded-lg shadow p-4 space-y-4">
      <h3 className="font-semibold text-gray-900">Guide Sections</h3>
      <ul className="space-y-2 text-sm">
        {/* General EV Tips */}
        <li>
          <button
            onClick={() => {
              handleMainTabClick("generalEV");
              setSidebarOpen?.(false);
            }}
            className={`w-full text-left px-2 py-1 rounded transition ${activeMainTab === "generalEV"
                ? "bg-blue-50 text-blue-700 font-medium"
                : "text-gray-600 hover:text-blue-600"
              }`}
          >
            General EV Tips
          </button>
        </li>

        {/* Cars group */}
        <li>
          <button
            onClick={() => handleMainTabClick("cars")}
            className={`w-full text-left px-2 py-1 rounded transition ${activeMainTab === "cars"
                ? "bg-blue-50 text-blue-700 font-medium"
                : "text-gray-600 hover:text-blue-600"
              }`}
          >
            Cars
          </button>

          {activeMainTab === "cars" && (
            <ul className="ml-4 mt-1 space-y-1">
              {carTabs.map((car) => (
                <li key={car.id}>
                  <button
                    onClick={() => {
                      handleCarClick(car.id);
                      setSidebarOpen?.(false);
                    }}
                    className={`block w-full text-left px-2 py-1 rounded ${activeCar === car.id
                        ? "bg-blue-100 text-blue-700 font-medium"
                        : "text-gray-500 hover:text-blue-600"
                      }`}
                  >
                    {car.label}
                  </button>

                  {activeCar === car.id && carSubTabConfig[car.id] && (
                    <ul className="ml-4 mt-1 space-y-1 hidden md:block">
                      {carSubTabConfig[car.id].map((sub) => {
                        const isActive =
                          activeCarSubTab === sub.id ||
                          (!activeCarSubTab && sub.id === carSubTabConfig[car.id][0].id);
                        return (
                          <li key={sub.id}>
                            <button
                              onClick={() => {
                                handleCarSubTabClick(car.id, sub.id);
                                setSidebarOpen?.(false);
                              }}
                              className={`block w-full text-left px-2 py-1 rounded ${isActive
                                  ? "bg-blue-200 text-blue-800"
                                  : "text-gray-500 hover:text-blue-600"
                                }`}
                            >
                              {sub.label}
                            </button>
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          )}
        </li>
      </ul>
    </nav>
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="hidden md:block fixed top-24 left-0 w-[280px]">
        <SidebarContent />
      </aside>

      {/* Mobile Drawer */}
      {sidebarOpen && (
        <div className="fixed inset-0 z-50 flex md:hidden">
          {/* Overlay */}
          <div
            className="fixed inset-0 bg-black bg-opacity-50"
            onClick={() => setSidebarOpen(false)}
          />
          {/* Drawer */}
          <div className="relative w-64 bg-white shadow-lg p-6 overflow-y-auto">
            <button
              className="absolute top-2 right-2 text-gray-600"
              onClick={() => setSidebarOpen(false)}
              aria-label="Close contents"
            >
              ✕
            </button>
            <SidebarContent />
          </div>
        </div>
      )}
    </>
  );
}